import { MapPin, EyeOff, ShieldCheck } from "lucide-react";
import { Reveal, Chapter, Hairline } from "./Reveal";
import { IMAGES } from "./constants";

const POINTS = [
  {
    icon: MapPin,
    title: "Kiara comes to you",
    body: "All training happens on-site at your own stables, anywhere in Dubai — no transporting your horse, no unfamiliar arenas, just calm and consistent work on familiar ground.",
  },
  {
    icon: EyeOff,
    title: "Exclusively for women horse owners",
    body: "Your sessions, your horse and your coaching remain completely among women — from the first enquiry to the final session.",
  },
  {
    icon: ShieldCheck,
    title: "A women's-only arena is all she needs",
    body: "If your stables have a women's-only arena, Kiara can come out for the training or service you want — complete privacy, on your own ground.",
  },
];

const Venue = () => (
  <section id="venue" data-testid="venue-section" className="relative bg-ebony py-28 lg:py-36">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid gap-16 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-7">
          <Reveal>
            <Chapter number="01" title="The Service" testId="venue-chapter" />
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-8 max-w-xl font-serif text-4xl font-light leading-tight tracking-tight text-offwhite md:text-5xl">
              The training comes to{" "}
              <em className="italic text-gold">you.</em>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-xl text-base font-light leading-relaxed text-cream/65 md:text-lg">
              No travel, no strange arenas, no stress for your horse. Kiara
              works on-site at your stables — where your horse is settled and
              you can watch every step of the process. And if your stables
              offer a women's-only arena, she will come out for exactly the
              training or service you need, in complete privacy.
            </p>
          </Reveal>

          <Reveal delay={0.3}>
            <div
              data-testid="venue-notice-card"
              className="mt-12 border border-champagne/20 bg-charcoal/60 p-8 shadow-[0_8px_32px_rgba(0,0,0,0.4)] backdrop-blur-2xl md:p-10"
            >
              {POINTS.map((p, i) => (
                <div key={i}>
                  {i > 0 && <Hairline className="my-8" />}
                  <div className="flex gap-6">
                    <p.icon
                      className="mt-1 shrink-0 text-gold"
                      size={22}
                      strokeWidth={1.25}
                    />
                    <div>
                      <h3 className="font-serif text-xl text-offwhite md:text-2xl">
                        {p.title}
                      </h3>
                      <p className="mt-2 text-sm font-light leading-relaxed text-cream/60">
                        {p.body}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={0.25} className="lg:mt-24">
            <div className="relative">
              <div className="absolute -inset-4 border border-gold/20" />
              <div className="group relative overflow-hidden">
                <img
                  src={IMAGES.portrait}
                  alt="Fine-art portrait of a bridled dressage horse"
                  data-testid="venue-image"
                  className="aspect-[3/4] w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-[1.04]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ebony/70 via-transparent to-transparent" />
                <p className="absolute bottom-6 left-6 text-[10px] uppercase tracking-[0.3em] text-cream/60">
                  On-Site Training · At Your Stables Across Dubai
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Venue;
